import {
  
  FETCH_ORDER_REQUEST,
  FETCH_ORDER_SUCCESS,
  FETCH_ORDER_FAILURE,

  CREATE_ORDER_REQUEST,
  CREATE_ORDER_SUCCESS,
  CREATE_ORDER_FAILURE,

  UPDATE_ORDER_REQUEST,
  UPDATE_ORDER_SUCCESS,
  UPDATE_ORDER_FAILURE,

  DELETE_ORDER_REQUEST,
  DELETE_ORDER_SUCCESS,
  DELETE_ORDER_FAILURE,
} from "./orderActionTypes";

const initialState = {
  orderData: [],
  loading: false,
  error: null,
};

const orderReducer = (state = initialState, action) => {
  switch (action.type) {
  
    case FETCH_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_ORDER_SUCCESS:



      return {
        ...state,
        loading: false,
        error: null,
        orderData: action.payload.data,
      };
    case FETCH_ORDER_FAILURE:
      return {
        ...state,
        loading: false,
        orderData: [],
        error: action.payload,
      };

    case CREATE_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CREATE_ORDER_SUCCESS:

      return {
        ...state,
        loading: false,
        orderData: action.payload.data,
        error: null,
      };
    case CREATE_ORDER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_ORDER_SUCCESS:

      return {
        ...state,
        loading: false,
        orderData: action.payload.data,


        error: null,
      };
    case UPDATE_ORDER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_ORDER_SUCCESS:

      return {
        ...state,
        loading: false,
        orderData: action.payload.data,
        error: null,
      };
    case DELETE_ORDER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default orderReducer;